export default __webpack_public_path__ + "static/before-3-e98706fab72668567502bb04b4d4abe9.jpeg";